<template>
  <el-container v-loading="isShowLoading">
    <div></div>
    <el-main>
      <el-row>
        <el-col :span="2" style="font-size:28px; text-align: center; padding-top: 19px">
          <el-tooltip
            class="item"
            effect="dark"
            content="返回上一级页面"
            placement="bottom-start"
            :disabled="showTooltip"
          >
            <i class="el-icon-arrow-left" @click="onBack" style="cursor: pointer"></i>
          </el-tooltip>
        </el-col>
        <el-col :span="12">
          <h3>
            <span>开票点收费项目明细管理</span>
          </h3>
        </el-col>
      </el-row>
      <div style="margin: 8px 40px 40px; border-bottom: 1px solid #CCC"></div>
      <el-row>
        <el-form :model="filterData" :inline="true">
          <el-form-item>
            <el-input v-model="filterData.auxItemCode" placeholder="请输入收费项目明细编码" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="filterData.auxItemName" placeholder="请输入收费项目明细名称" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" icon="el-icon-search" @click="onFilter">查询</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="onAdd">手工新增</el-button>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="onAddAll">一键新增</el-button>
        </el-col>
      </el-row>

      <el-table
        ref="singleTable"
        :data="recordData"
        highlight-current-row
        style="width: 100%"
        height="400px"
        :row-style="{height:'30px'}"
        :cell-style="{padding:'2px'}"
        :header-cell-style="{background:'#f5f7fa', color: 'black'}"
        border
        @row-dblclick="onRowDblclick"
        :stripe="stripeVisible"
      >
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column property="placeName" label="开票点名称" width="180" show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="placeCode" label="开票点编码" width="100" show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="itemName" label="收费项目名称" width="120" show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="itemCode" label="收费项目编码" width="120" show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="auxItemName" label="收费项目明细名称" width="140" show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="auxItemCode" label="收费项目明细编码" width="140" show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="auxItemUnit" label="收费项目明细单位" width="140" show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="auxItemStd" label="收费项目明细标准" width="140" show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="auxItemRemark" label="收费项目明细备注" width="140" show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="150">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="onDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row style="margin: 8px 8px">
        <el-col :span="24">
          <pagination
            v-show="pagination.total/pagination.pageSize>1"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
            :page.sync="pagination.page"
            :limit.sync="pagination.pageSize"
            @pagination="onFilter"
          />
        </el-col>
      </el-row>

      <div style="height: 60px"></div>
      <!-- <el-dialog
        :visible.sync="chooseItemAuxViewVisible"
        :show-close="false"
        :wrapperClosable="false"
        :withHeader="false"
        :size="pageWidth + 'px'"
        direction="rtl"
        custom-class="demo-drawer"
        style="top: 67px"
      >
        <div class="demo-dialog-content">
          <ChooseItemAuxView
            v-if="chooseItemAuxViewVisible"
            @back="back"
            @reload="init"
            v-bind:entity="entityData"
            ref="itemPanel"
          ></ChooseItemAuxView>
        </div>
      </el-dialog>-->

      <el-dialog
        width="900px"
        :visible.sync="chooseItemAuxViewVisible"
        :destroy-on-close="true"
        title="选择收费项目明细"
        :modal-append-to-body="true"
        :append-to-body="true"
      >
        <ChooseItemAuxView
          style="height:550px;"
          v-if="chooseItemAuxViewVisible"
          @back="back"
          v-bind:entity="entityData"
          ref="itemPanel"
          show-close="true"
        ></ChooseItemAuxView>
        <el-row></el-row>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
import ChooseItemAuxView from "./ChooseItemAuxView.vue"; //导入选择收费项目明细

let _kits, _table;
export default {
  props: ["itemAuxEntityData"],
  components: {
    ChooseItemAuxView
  },
  data() {
    return {
      isShowLoading: true,
      chooseItemAuxViewVisible: false,
      isShowItem: false,
      pageWidth: 600,
      showTooltip: false,
      //页面布局相关
      layout: {
        loading: true,
        width: 600,
        wd: "80%"
      },
      //数据绑定相关
      filterData: {
        agencyCode: this.itemAuxEntityData.agencyCode,
        placeCode: this.itemAuxEntityData.placeCode,
        itemCode: this.itemAuxEntityData.itemCode,
        auxItemCode: "",
        auxItemName: ""
      }, //过滤信息
      recordData: [], //展示信息
      pagination: {
        total: 0,
        page: 1,
        pageSize: 10
      }, //分页信息
      entityData: {
        agencyCode: this.itemAuxEntityData.agencyCode,
        placeCode: this.itemAuxEntityData.placeCode,
        itemCode: this.itemAuxEntityData.itemCode
      } //具体某一项信息
    };
  },
  methods: {
    onAdd() {
      this.chooseItemAuxViewVisible = true;
    },
     onAddAll() {
      _kits.confirm({
        text: "确定要添加全部收费项目明细?",
        yes: () => {
          this.layout.loading = true;
          _kits.message("正在添加");
        _kits.api.call(
        "SAVEAGENCYPLACEITEMAUXBYITEMCODE",
        {
          agencyCode: this.filterData.agencyCode,
          placeCode: this.filterData.placeCode,
          itemCode: this.filterData.itemCode
        },
        result => {
          if (result.returnCode == "0000") {
            this.$message.success(result.returnMsg);
                this.init();
          } else {
            this.$message.error(result.returnMsg);
          }
        }
      );

        }
        });
    },
    onRowDblclick(row, column, event) {
      console.log(row);
    },
    onDel(item) {
      var list = [];
      list.push(item);
      _kits.confirm({
        text: "确定删除此接口?",
        yes: () => {
          this.layout.loading = true;
          _kits.message("正在删除接口");

        _kits.api.call(
        "DELETEAGENCYPLACEITEMAUX",
        {
          list: list,
          agencyCode: this.filterData.agencyCode,
          placeCode: this.filterData.placeCode,
          itemCode: this.filterData.itemCode
        },
        result => {
          if (result.returnCode == "0000") {
            this.$message.success(result.returnMsg);
                this.init();
          } else {
            this.$message.error(result.returnMsg);
          }
        }
      );

        }
      });
    },
    onFilter() {
      this.layout.loading = true;
      _table.load();
    },
    init() {
      _table.load();
    },
    back() {
      this.chooseItemAuxViewVisible = false;
      this.layout.loading = true;
      _table.load();
    },
    onBack() {
      this.$emit("back");
    }
  },
  created() {
    this.pageWidth = window.innerWidth - 200;
    _kits = this.$kits();
    _table = _kits.table(
      "QUERYPLACEITEMAUXLIST",
      () => {
        return Object.assign({}, this.filterData, this.pagination);
      },
      result => {
        this.isShowLoading = false;
        this.recordData = result.list;
        this.pagination.total = Number.parseInt(result.total);
      }
    );
    this.init();
  },
  mounted() {
    setTimeout(() => {
      _kits.page.foucus("ipt01");
      this.showLoading = false;
      this.showTooltip = true;
    }, 300);
  }
};
</script>
<style scoped>
</style>
